import { loyaltyPromotionSchema } from "@redotech/redo-model/loyalty/loyalty-definition";
import * as z from "zod/v4";

export const deleteLoyaltyPromotion = {
  name: "deleteLoyaltyPromotion" as const,
  input: z.object({ promotionId: z.string() }),
  output: loyaltyPromotionSchema,
};
